<template>
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.75 4.75v28.5h28.5m-3.167-19-7.916 7.917-6.334-6.334-4.75 4.75"
      stroke-width="2.375"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
